import React from "react";
import { useAuth } from "@/lib/auth-context";
import { Button } from "@/components/ui/button";
import { LogOut, Shield, User } from "lucide-react";

export function UserMenu() {
  const { user, logout } = useAuth();

  if (!user) return null;

  const handleLogout = () => {
    if (confirm("Are you sure you want to sign out?")) {
      logout();
    }
  };

  return (
    <>
      {/* Desktop User Menu */}
      <div className="hidden md:flex items-center gap-3">
        <div className="flex items-center gap-2 text-sm">
          <div className="flex items-center justify-center w-8 h-8 rounded-full bg-primary/10">
            <User className="h-4 w-4" />
          </div>
          <div className="flex flex-col">
            <span className="font-medium">{user.username}</span>
            {user.admin && (
              <span className="text-xs text-muted-foreground flex items-center gap-1">
                <Shield className="h-3 w-3" />
                Administrator
              </span>
            )}
          </div>
        </div>
        <Button variant="outline" size="sm" onClick={handleLogout}>
          <LogOut className="h-4 w-4 mr-2" />
          Sign out
        </Button>
      </div>

      {/* Mobile User Menu */}
      <div className="md:hidden flex items-center gap-4">
        <div className="flex flex-col text-right">
          <span className="text-sm font-medium">{user.username}</span>
          {user.admin && (
            <span className="text-xs text-muted-foreground flex items-center justify-end gap-1">
              <Shield className="h-3 w-3" />
              Admin
            </span>
          )}
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={handleLogout}
          className="text-xs px-3 py-1.5 h-auto"
        >
          Sign Out
        </Button>
      </div>
    </>
  );
}

export default UserMenu;
